import { gql } from '@apollo/client';

export const GET_INVOICES_LIST = gql`
  query GetInvoicesList(
    $first: Int = 24
    $after: String
    $status: InvoiceStatusEnum
  ) {
    currentUserInvoices(first: $first, after: $after, status: $status) {
      totalCount
      nodes {
        id
        legacyResourceId
        service
        amount
        status
        invoiceDate
        statusDatetime
        paymentSource
        printUrl
        discount
        vatAmount
        startsAt
        expiresAt
        period
        paidAdsCount
        walletAmount
        customerName
        customerTin
        contractNumber
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
